import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/typing.gif'


const _hoisted_1 = ["initial", "enter"]
const _hoisted_2 = {
  key: 0,
  id: "homero-message",
  class: "w-full flex items-start flex-col space-y-2"
}
const _hoisted_3 = {
  key: 0,
  class: "font-[800] capitalize text-h-info-500"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-h-primary-100 p-4 drop-shadow-lg rounded-md"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "my-5"
}
const _hoisted_7 = { class: "w-48 flex flex-row space-x-2 mt-4" }
const _hoisted_8 = {
  key: 2,
  id: "keywords",
  class: "pt-5 flex flex-col gap-5"
}
const _hoisted_9 = {
  key: 3,
  class: "p-4 drop-shadow-lg flex flex-col space-y-2 rounded-md"
}
const _hoisted_10 = {
  key: 1,
  id: "my-messages",
  class: "w-full flex items-end flex-col space-y-2"
}
const _hoisted_11 = { class: "text-h-primary-500 font-[800] capitalize" }
const _hoisted_12 = { class: "msg-box bg-white p-4 drop-shadow-md text-right rounded-md break-words" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["id", "src"]
const _hoisted_16 = {
  key: 0,
  class: "msg-box bg-white p-4 drop-shadow-md text-right rounded-md w-[12%] my-5"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "typing",
  loading: "lazy",
  class: "w-full"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: index,
        class: "mb-12",
        initial: {
      opacity: 0,
      x: item.user == 'homero' && index == _ctx.messages.length - 1 ? -50 : 0,
    },
        enter: _ctx.enterMotion
      }, [
        (item.user == 'homero')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (item.message)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(item.user), 1))
                : _createCommentVNode("", true),
              (item.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("p", {
                      innerHTML: item.message
                    }, null, 8, _hoisted_5),
                    (item === _ctx.messages[_ctx.messages.length - 1] && _ctx.action.isGpt)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Deseja pesquisar sobre vídeos relacionados no curso?",
              en: "Want to search for related videos in the course?",
            })), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_MessageVoice, {
                        msg: _ctx.removeTags(item.message),
                        showIconsName: false,
                        autoPlay: _ctx.autoPlay
                      }, null, 8, ["msg", "autoPlay"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item === _ctx.messages[_ctx.messages.length - 1] && _ctx.action.isGpt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_Button, {
                      label: "Sim, eu quero!",
                      class: "btn-outline p-button-sm w-fit h-10",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onOpenCrawler('')))
                    })
                  ]))
                : _createCommentVNode("", true),
              (item.options.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, i) => {
                      return (_openBlock(), _createElementBlock("span", { key: i }, [
                        (option.active)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              label: option.name,
                              onClick: option.action,
                              class: _normalizeClass(`btn-outline hidden`),
                              disabled: !option.active
                            }, null, 8, ["label", "onClick", "disabled"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (item.user == 'me')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Você",
            en: "You",
          })), 1),
              _createElementVNode("div", _hoisted_12, [
                (item.type == 'text')
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      innerHTML: item.message
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true),
                (item.type == 'audio')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                      _createElementVNode("audio", {
                        id: 'audio' + index,
                        src: item.audio,
                        controls: ""
                      }, null, 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1)), [
        [_directive_motion]
      ])
    }), 128)),
    (_ctx.loaderMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
      : _createCommentVNode("", true)
  ], 64))
}